import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.aviabookingSavedDocuments
)

export const selectSavedDocuments = createSelector(
    baseSelector,
    (state) => state.savedDocuments
)

export const selectSavedDocumentsError = createSelector(
    baseSelector,
    (state) => state.savedDocumentsError
)

export const selectSavedDocumentsLoading = createSelector(
    baseSelector,
    (state) => state.isSavedDocumentsLoading
)

export const selectSavedDocumentsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isSavedDocumentsFirstLoad
)
